import { TabsNav as TabsNavBase } from '@hotjar/feedback/components/common/TabsNav';

interface TabsNavProps {
  onTabClick: (value: string) => void;
  selectedValue: string;
}

const feedbackTabs = [
  {
    label: 'tabsnav.feedback.responses',
    value: 'responses',
  },
  {
    label: 'tabsnav.feedback.results',
    value: 'results',
  },
];

export function TabsNav({ onTabClick, selectedValue }: TabsNavProps): JSX.Element {
  return <TabsNavBase onTabClick={onTabClick} selectedValue={selectedValue} tabs={feedbackTabs} />;
}
